import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextField, TextFieldProps } from '@anytag/shared-molecules';

import { MarketplaceFormValues, MarketplaceFormKeys } from '../types';

export const RevenueField = (props: Omit<TextFieldProps, 'name'>) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<MarketplaceFormValues>();
  const currency = watch(MarketplaceFormKeys.currency);

  return (
    <TextField
      rightSection={t(currency)}
      placeholder="50000"
      title={t('TextForm.Max Revenue')}
      help={t('Tooltip.Max Revenue Help')}
      name={MarketplaceFormKeys.maximumRevenuePerInfluencer}
      {...props}
    />
  );
};
